const riot = require('riot');

riot.tag2('modal-dialog', '<div class="modal relative elevation-default-mid bg-white rounded-4 {getModalClasses()} {&quot;border border-red_70&quot; : opts.danger}" ref="modal"><i class="icon-close absolute t8 r8 fs24 text-gray_30 cursor-pointer" onclick="{close}"></i> <div if="{!opts.size || opts.size === &quot;large&quot;}"> <div class="px40 mb40"> <div class="f fh" if="{opts.danger}"><img class="s84 mb12" src="/images/exclamation.svg"></div> <div class="text-center ts-hm text-center mb36 {opts.danger ? &quot;text-red_70&quot; : &quot;text-navy&quot;}">{opts.title || \'確認\'}</div> <div if="{opts.text}"> <div class="ts-pm text-navy word-break-all white-space-pre-wrap" if="{opts.text}">{opts.text}</div> </div> </div> <div class="f fr pt20 px40 border-top border-navy_05"> <button class="button mr12 {opts.negative_button_type}" onclick="{cancel}">{opts.negative || \'キャンセル\'}</button> <button class="button {getPositiveButtonClass()}" onclick="{agree}">{opts.positive || \'OK\'}</button> </div> </div> <div if="{opts.size === &quot;medium&quot;}"> <div class="px32 mb40"> <div class="f fh" if="{opts.danger}"> <img class="s84 mb12" src="/images/exclamation.svg"></div> <div class="text-center ts-hm text-center mb24 {opts.danger ? &quot;text-red_70&quot; : &quot;text-navy&quot;}">{opts.title || \'確認\'}</div> <div if="{opts.text}"> <div class="ts-pm text-navy word-break-all white-space-pre-wrap" if="{opts.text}">{opts.text}</div> <div class="mt20" if="{opts.check_form}"> <div class="f fm mb8"> <div class="ts-hxs text-gray_80 mr4">{opts.check_form.key}</div> <div class="ts-hxxs text-pink_70">必須</div> </div> <input class="w-full input" ref="input" oninput="{onInput}"> </div> </div> </div> <div class="f fr pt20 px32 border-top border-navy_05"> <button class="button mr12 {opts.negative_button_type}" onclick="{cancel}">{opts.negative || \'キャンセル\'}</button> <button class="button {getPositiveButtonClass()}" onclick="{agree}">{opts.positive || \'OK\'}</button> </div> </div> <div class="px24" if="{opts.size === &quot;small&quot;}"> <div class="mb20"> <div class="f fm mb20"><img class="s44 mr12" if="{opts.danger}" src="/images/exclamation.svg"> <div class="text-center ts-hs {opts.danger ? &quot;text-red_70&quot; : &quot;text-navy&quot;}">{opts.title || \'確認\'}</div> </div> <div if="{opts.text}"> <div class="ts-ps text-gray_60 word-break-all white-space-pre-wrap" if="{opts.text}">{opts.text}</div> </div> </div> <div class="f fr"> <button class="button mr8 {opts.negative_button_type}" onclick="{cancel}">{opts.negative || \'キャンセル\'}</button> <button class="button {getPositiveButtonClass()}" onclick="{agree}">{opts.positive || \'OK\'}</button> </div> </div> </div>', 'modal-dialog .modal,[data-is="modal-dialog"] .modal{max-width:80vw}', 'class="f fh s-full px16 bg-modal_overlay" spat-animation="fade"', function(opts) {
    this.isAgree = false;

    this.cancel = () => {
      this.value = false;
      this.close();
    };

    this.agree = () => {
      if (this.opts.check_form) {
        if (this.isAgree) {
          this.value = true;
          this.close();
          return;
        }
        else {
          spat.modal.alert('予期せぬエラーが発生しました');
          this.close();
          return;
        }
      }
      this.value = true;
      this.close();
    };

    this.onInput = () => {
      var result = this.refs.input.value === this.opts.check_form.value;
      if (result) {
        this.isAgree = true;
        this.update();
        return;
      }
      this.isAgree = false;
      this.update();
    };

    this.getModalClasses = () => {
      var size = this.opts.size || 'large';
      return {
        large: 'w760 pt40 pb20',
        medium: 'w440 pt32 pb20',
        small: 'w500 py24',
      }[size];
    };

    this.getPositiveButtonClass = () => {
      var active_color = this.opts.positive_button_type ? this.opts.positive_button_type : 'primary';

      if (this.opts.danger) {
        active_color = 'danger';
      }
      return (!this.opts.check_form || this.isAgree) ? active_color : "disabled";
    };
});